import * as React from 'react';
// Import hooks.
import {
	useInputNumber,
	UseInputNumberResults,
} from '@app/hooks/view/input';
// Import app models.
import {
	ValidatorResponse,
} from '@app/models/app';

interface UseInputLienholderPositionParameters {
	id: string;
	infoText?: string;
	required: boolean;
	disabled: boolean;
	value?: number;
	showValidation?: boolean;
	lienholderPositionsInUse?: number[];
}

type UseInputLienholderPositionResults = UseInputNumberResults;

const useInputLienholderPosition = (params: UseInputLienholderPositionParameters): UseInputLienholderPositionResults => {

	// #region private methods

	// #region id generators

	/**
	 * Generates id for the input. 
	 **/
	const generateIdForInput = (): string => {
		return params.id;
	}

	/**
	 * Generates id for lienholder position. 
	 **/
	const generateIdForLienholderPosition = (): string => {
		return `${generateIdForInput()}-lienholderPosition`;
	}

	// #endregion id generators

	/**
	 * Validates the current value.
	 * @param value
	 */
	const validateLienholderPosition_InUse = (value: number | undefined, required: boolean): ValidatorResponse => {
		let response: ValidatorResponse = new ValidatorResponse(true, String.empty());

		if (value !== undefined
			&& lienholderPositionsInUse.some((lienholderPositionInUse) => lienholderPositionInUse === value)) {
			response = new ValidatorResponse(false, `The specified ${validationLabel} is already in use.`);
		}

		return response;
	}

	// #endregion private methods


	// #region variables

	const validationLabel: string = 'lienholder position';
	const lienholderPositionsInUse: number[] = React.useMemo(() => params.lienholderPositionsInUse ?? [], [params.lienholderPositionsInUse]);

	// Instantiate the 'lienholder position' input hook.
	const lienholderPositionInput: UseInputNumberResults = useInputNumber({
		id: generateIdForLienholderPosition(),
		label: 'Lienholder Position',
		validationLabel: validationLabel,
		required: params.required,
		disabled: params.disabled,
		value: params.value,
		showValidation: params.showValidation,
		infoText: params.infoText,
		minValue: 0,
		validators: [validateLienholderPosition_InUse],
	});

	// #endregion variables

	return lienholderPositionInput;
}

// Export parameters.
export {
	UseInputLienholderPositionParameters,
}

// Export results.
export {
	UseInputLienholderPositionResults,
}

export default useInputLienholderPosition;